import { Accordion, Card } from "react-bootstrap";

import CustomAccordionToggle from "../../../base/CustomAccordionToggle";
import { AccordionItemProps } from "./interface";

const AccordionItem = ({
  eventKey,
  body,
  headerTitle,
  onClick
}: AccordionItemProps) => {
  return (
    <Card onClick={onClick}>
      <Card.Header>
        <CustomAccordionToggle eventKey={eventKey}>
          {headerTitle}
        </CustomAccordionToggle>
      </Card.Header>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body>{body}</Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default AccordionItem;
